import { createContext } from "react";

export const NoteContext = createContext({
  isRejected: false,
  setIsRejected: () => { },
});

export const GameContext = createContext({
  gameValue: false,
  setGameValue: () => { },
});

export const WalletContext = createContext({
  walletConnection: false,
  setWalletConnection: () => { },
});

export const PaymentValidation = createContext({
  paymentValidation: false,
  setPaymentValidation: () => { },
  transaction: false,
  setTransaction: () => { },
})

export const AuthInfo = createContext({
  userAddress: '',
  setUserAddress: () => { },
})
export const ErrorContext = createContext({
  IsError: '',
  setIsError: () => { },
})